// extracted by mini-css-extract-plugin
export default {"modal":"ModalVerification_modal__JfqMi","modal_content":"ModalVerification_modal_content__An8MW"};